// この端末にだけ置く小さな記録：遊んだゲームの一覧・自己ベスト（ゲスト用）・音の入切。
// 個人の情報は置かない。読めない・書けない環境（プライベートの窓など）でも止まらない。
const RECENT_KEY = "appful:recent";
const MUTED_KEY = "appful:muted";
const bestKey = (gameId: string, boardId: string) => `appful:best:${gameId}:${boardId}`;

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

function write(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* 保存できない環境でも遊びは止めない */
  }
}

export interface Recent {
  id: string;
  at: number;
}

export function recentGames(): Recent[] {
  const list = read<Recent[]>(RECENT_KEY, []);
  return Array.isArray(list) ? list.filter((r) => typeof r?.id === "string") : [];
}

export function markPlayed(id: string) {
  write(RECENT_KEY, [{ id, at: Date.now() }, ...recentGames().filter((r) => r.id !== id)].slice(0, 12));
}

/** ゲストの自己ベスト。今回の点が前より良ければ書きかえ、良くなったかを返す */
export function updateLocalBest(gameId: string, boardId: string, score: number, order: "asc" | "desc"): boolean {
  const prev = read<number | null>(bestKey(gameId, boardId), null);
  const better = prev === null || (order === "desc" ? score > prev : score < prev);
  if (better) write(bestKey(gameId, boardId), score);
  return better;
}

export function isMuted(): boolean {
  return read<boolean>(MUTED_KEY, false) === true;
}

export function setMuted(muted: boolean) {
  write(MUTED_KEY, muted);
}

/** この端末のデータ（続き・遊んだ一覧・自己ベスト）を消す。言語と音の設定は残す */
export function clearDeviceData() {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key === RECENT_KEY || key.startsWith("appful:save:") || key.startsWith("appful:best:")) localStorage.removeItem(key);
    }
  } catch {
    /* 何もしない */
  }
}
